(function () {
  var header = document.querySelector('.header-section');
  var headerSkin = document.querySelector('.site-header__element');
  if (!header || !headerSkin) return;

  var lastY = window.pageYOffset || 0;
  var ticking = false;

  // Tunables
  var THRESHOLD   = 6;   // ignore tiny scrolls
  var TOP_RESET   = 10;  // near top => absolute + transparent
  var SHOW_BG_AT  = 20;  // add white bg once you’ve moved a bit

  function applyTopState(y) {
    if (y <= TOP_RESET) {
      // Back to page top: absolute & transparent
      header.classList.remove('is-sticky', 'is-hidden');
      headerSkin.classList.remove('has-bg');
      return true;
    }
    return false;
  }

  function onScroll() {
    var y = window.pageYOffset || 0;
    if (Math.abs(y - lastY) < THRESHOLD) return;

    var scrollingDown = y > lastY;
    lastY = y;

    // If we're near the very top, reset to absolute & transparent
    if (applyTopState(y)) return;

    // From here on, remain sticky to allow smooth animations
    header.classList.add('is-sticky');

    if (scrollingDown) {
      // Fade/slide out but KEEP sticky; remove bg
      header.classList.add('is-hidden');
      headerSkin.classList.remove('has-bg');
    } else {
      // Scrolling up: reveal & add bg once past small offset
      header.classList.remove('is-hidden');
      if (y > SHOW_BG_AT) {
        headerSkin.classList.add('has-bg');
      } else {
        headerSkin.classList.remove('has-bg');
      }
    }
  }

  function scrollHandler() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Initialize appropriately from current position
  (function init() {
    var y = window.pageYOffset || 0;
    if (!applyTopState(y)) {
      header.classList.add('is-sticky');
      if (y > SHOW_BG_AT) headerSkin.classList.add('has-bg');
    }
  })();

  window.addEventListener('scroll', scrollHandler, { passive: true });
})();